import { Component, OnInit } from '@angular/core';

import { ChatService, ChatStatus } from '../services/chat.service';

@Component({
	selector: 'zen-chat',
	templateUrl: './chat.component.html',
	styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
	listTitle = 'Conversas';
	videoConference = false;
	constructor(public chatService: ChatService) {}

	ngOnInit() {
		this.chatService.setInboxElement(
			document.getElementById('chat-div-container')
		);

		this.chatService.displayModeSub.subscribe({
			next: (state: string) =>
				(this.videoConference = state === 'videoConference'),
		});
	}

	getUnreadMessage() {
		return this.chatService.unreadMessage;
	}

	goToUnreadMessage() {
		this.chatService.openUnreadMessage();
	}

	isChatOpen() {
		return this.chatService.isChatOpen;
	}

	closeChat() {
		this.chatService.setChatOpen(false, '');
	}

	chatHasError() {
		return this.chatService.status === ChatStatus.error;
	}
}
